<template>
  <LoadSpinner v-if="loading"></LoadSpinner>
  <div class="card flex justify-center" v-else>
    <table class="m-2" v-if="!isKonfirmasi">
      <tr>
        <td>Tanggal</td>
        <td>:</td>
        <td>{{formulir.tgl}}</td>
      </tr>
      <tr>
        <td>No Inv</td>
        <td>:</td>
        <td>{{formulir.noinv}}</td>
      </tr>
      <tr>
        <td>Jumlah</td>
        <td>:</td>
        <td>{{formulir.hargaformulir}}</td>
      </tr>
      <tr v-if="getVA() && getVA().trim()">
        <td>Nama Bank</td>
        <td>:</td>
        <td>{{getBankName()}}</td>
      </tr>
      <tr v-if="getVA() && getVA().trim()">
        <td>Virtual Account</td>
        <td>:</td>
        <td><b>{{getVA()}}</b></td>
      </tr>
      <tr v-if="getVA() && getVA().trim()">
        <td colspan="3">
          <button
              class="btn btn-outline-primary w-100 h-100 rounded-0"
              type="button"
              id="copyButton"
              @click="copyText(formulir.kodeva)"
          >
            <i class="bi bi-clipboard"></i>
            <span>Salin Kode VA</span>
          </button>
        </td>
      </tr>
      <tr v-if="getVA() && getVA().trim()">
        <td>Batas waktu</td>
        <td>:</td>
        <td v-if="isExpired()" style="background-color: red; color: white;">{{getExpiredDate()}}</td>
        <td v-else>{{getExpiredDate()}}</td>
      </tr>
      <tr v-if="isExpired()">
        <td colspan="3">Kode VA kadaluarsa, silakan buat kode VA kembali</td>
      </tr>
    </table>
    <table class="m-2" v-else>
      <tr class="bg-light p-2">
        <td>Total</td>
        <td>:</td>
        <td>{{formulir.hargaformulir}}</td>
      </tr >
      <tr>
        <td>Nama Bank</td>
        <td>:</td>
        <td>{{getBankName()}}</td>
      </tr>
      <tr>
        <td>Virtual Account</td>
        <td>:</td>
        <td><b>{{getVA()}}</b></td>
      </tr>
      <tr>
        <td>Batas waktu</td>
        <td>:</td>
        <td v-if="isExpired" style="background-color: red; color: white;">{{getExpiredDate}}</td>
        <td v-else>{{getExpiredDate}}</td>
      </tr>
      <tr v-if="isExpired">
        <td colspan="3">Kode VA yang terbit sudah kadaluarsa, silakan buat kode VA kembali</td>
      </tr>
      <tr class="p-2">
        <td colspan="3" class="text-center font-weight-bold">Rincian</td>
      </tr >
      <template v-for="(item,idx) in formulir.data" :key="idx">
        <tr>
          <td>Tanggal</td>
          <td>:</td>
          <td>{{item.tgl}}</td>
        </tr>
        <tr>
          <td>No Inv</td>
          <td>:</td>
          <td>{{item.noinv}}</td>
        </tr>
        <tr>
          <td>Jumlah</td>
          <td>:</td>
          <td>{{item.hargaformulir}}</td>
        </tr>
      </template>
    </table>
    <div class="w-full md:w-56 m-2">
      Cara penerbitan kode VA Pembayaran
      <ol>
        <li>Pilih channel pembayaran, tombol membuat kode VA akan muncul setelah channel dipilih</li>
        <li>Klik tombol membuat kode VA</li>
        <li>Gunakan Kode VA untuk melakukan pembayaran</li>
        <li>Perhatikan tanggal kadaluarsa VA</li>
        <li>Jika VA kadaluarsa, silakan lakukan langkah no 2 kembali</li>
      </ol>
    </div>

    <Select v-model="selectedPayment" :options="paymentList" optionLabel="name" placeholder="Pilih channel pembayaran" class="w-full md:w-56 m-2" />
    <button v-if="Object.keys(selectedPayment).length>0" @click="doPaymentFormulir(formulir)" class="mt-3 btn btn-sm btn-success"><i class="fa-solid fa-caret-right"></i>Buat Kode VA</button>
    <Card v-if="messagetrx.length>0">
      <template #title>Informasi Pembayaran</template>
      <template #content>
        <p>{{messagetrx}}</p>
        <div v-html="infopembayaran" />
      </template>
    </Card>
  </div>
</template>

<script>
import Select from 'primevue/select';
import LoadSpinner from "@/components/LoadSpinner";
import DashboardServices from "@/services/dashboard.services";
import Card from 'primevue/card';
export default {
  name: "PaymentOption",
  props:{
    formulir :undefined,
    isKonfirmasi: Boolean,
    path:String,
  },
  components:{Select,LoadSpinner,Card},
  data:()=>({
    loading: false,
    response: "",
    success: false,
    selectedPayment: "",
    infopembayaran:"",
    paymentList:[],
    dataPembayaran:[],
    messagetrx:"",
    vaLocal: "",
    bankLocal: "",
    expiredDateLocal:"",
    isexpiredLocal: ""
  }),
  methods:{
    getVA() {
      return this.vaLocal
    },
    getBankName() {
      return this.bankLocal
    },
    getExpiredDate(){
      return this.expiredDateLocal
    },
    isExpired(){
      return this.isexpiredLocal
    },
    getPaymentOptions(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {};
      let path = '/dashboard/listPaymentOptions';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.paymentList = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    doPaymentFormulir(formulir){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = {
        paymentchannel:this.selectedPayment,
        data:formulir
      };
      let path = this.path;
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.messagetrx = response.data.message;
              this.dataPembayaran = this.response.data;
              if(this.dataPembayaran.Status==='SUCCESS'){
                this.infopembayaran = this.dataPembayaran.infopembayaran;
                this.vaLocal = this.dataPembayaran.kodeva;
                this.bankLocal = this.dataPembayaran.bankname;
                this.expiredDateLocal = this.dataPembayaran.expired.tanggal;
                this.isexpiredLocal = false
              }else{
                this.messagetrx = 'Mohon coba kembali';
              }
            }else {
              this.messagetrx = response.data.message;
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text)
        alert('Berhasil disalin!')
      } catch (error) {
        console.error('Gagal copy:', error)
      }
    }
},
  mounted() {
    this.getPaymentOptions();
    this.vaLocal = this.formulir?.kodeva || '';
    this.bankLocal = this.formulir?.bankname || '';
    this.expiredDateLocal = this.formulir?.expired || '';
    this.isexpiredLocal = this.formulir?.isexpired || '';
  }
}
</script>

<style scoped>

</style>